import { render, staticRenderFns } from "./Veroeffentlichen.vue?vue&type=template&id=3aafea0b&scoped=true&"
import script from "./Veroeffentlichen.vue?vue&type=script&lang=js&"
export * from "./Veroeffentlichen.vue?vue&type=script&lang=js&"
import style0 from "./Veroeffentlichen.vue?vue&type=style&index=0&id=3aafea0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aafea0b",
  null
  
)

export default component.exports